import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type fcsyCredType = CarrierLogisticsCredType
export const fcsyDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const fcsy: CarrierDef<fcsyCredType> = {
  name: 'STG LTL',
  scac: 'fcsy',
  ...carrierLogistics,
  engineLayers: ['documents', 'rating', 'pickup', 'profinder', 'tracking'],
  documentTypes: fcsyDocumentTypes,
}
